import common from './en-US/common';
import tools from './en-US/tools';
import upload from './en-US/upload';
import report from './en-US/report-summary';
import text2sql from './en-US/text2sql';
import gptTranslator from './en-US/gptTranslator';
import dataAnalysis from './en-US/dataAnalysis';
import motionCapture from './en-US/motion-capture';
import agentChat from './en-US/agentChat';
export default {
  ...common,
  ...tools,
  ...upload,
  ...report,
  ...text2sql,
  ...gptTranslator,
  ...dataAnalysis,
  ...motionCapture,
  ...agentChat,
};
